<template>
  <div
    class="parent flex flex-col items-center justify-items-center justify-center p-3 pb-0 mb-0"
  >
    <div class="w-56 text-sm text-center mb-0 pb-0">
      <p class="leading-5 mb-0 pb-0">{{ data.text }}</p>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  props: {
    data: Object,
  },
  setup() {
    const primaryTextClamp = ref(true);
    const copied = ref(false);
    const togglePrimaryTextClamp = () => {
      primaryTextClamp.value = !primaryTextClamp.value;
    };
    const copyToClipboard = (value) => {
      navigator.clipboard.writeText(value);
      copied.value = true;
      setTimeout(() => {
        copied.value = false;
      }, 3000);
    };

    return {
      primaryTextClamp,
      togglePrimaryTextClamp,
      copyToClipboard,
      copied,
    };
  },
};
</script>

<style scoped>
/* .post {
  filter: blur(8px);
} */
.text-606770 {
  color: #606770;
}
.square {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 5px;
  background-color: #fff;
}
.square img {
  border-radius: 10px;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.discount {
  max-width: 10rem;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  height: 30px;
  background-position: 0 0;
  border: 1px solid #667eea;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
.parent {
  width: 200px;
  height: 100px;
  position: relative;
}
</style>
